import styled from 'react-emotion';
import theme from '@ublend-npm/aulaui-next-web/themes/default';

export const Container = styled('div')`
  width: 100%;
  height: 100%;
  background: ${theme.color.white};
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &.leftPanel {
    overflow-x: hidden;

    .leftPanel__navigation {
      height: 50%;
      overflow: auto;
    }

    .leftPanel__main,
    .leftPanel__footer {
      flex-shrink: 0;
    }
  }
`;

export const TopHalf = styled('div')``;

export const CloseButton = styled('div')`
  margin-left: 12px;
  margin-top: 12px;
  width: 48px;
  height: 48px;
  border-radius: ${theme.borderRadius.medium};
  color: ${theme.color.purple};
  background-color: rgba(133, 67, 192, 0.08);
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-right: 16px;

  &:hover {
    background-color: rgba(133, 67, 192, 0.2);
  }

  &:active {
    background-color: rgba(133, 67, 192, 0.08);

    svg {
      opacity: 0.56;
    }
  }
`;
